import { getAvailableTermsForSku, getCommonAllowedQueryParamTerm, getCommonAvailableTerms, getPurchaseRequestTermsFromProductConfigurations, getValidatedQueryParamTermForCrmSuite } from 'pricing-pages-lib/utils/offerUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';

/**
 * @deprecated Please use one of the POP hooks in usePurchaseOptions.ts or useBulkPurchaseOptions.ts
 */
export const commonAvailableTermsSelector = createSelectorFromUtil(getCommonAvailableTerms, transformState);

/**
 * @deprecated Please use one of the POP hooks in usePurchaseOptions.ts or useBulkPurchaseOptions.ts
 */
export const availableTermsForSkuSelector = createSelectorFromUtil(getAvailableTermsForSku, transformState);

/**
 * @deprecated Please use one of the POP hooks in usePurchaseOptions.ts or useBulkPurchaseOptions.ts
 */
export const validateQueryParamTermForCrmSuiteSelector = createSelectorFromUtil(getValidatedQueryParamTermForCrmSuite, transformState);

/**
 * @deprecated Please use one of the POP hooks in usePurchaseOptions.ts or useBulkPurchaseOptions.ts
 */
export const commonAllowedQueryParamTermSelector = createSelectorFromUtil(getCommonAllowedQueryParamTerm, transformState);

/**
 * @deprecated Please use one of the POP hooks in usePurchaseOptions.ts or useBulkPurchaseOptions.ts
 */
export const purchaseRequestTermsFromProductConfigurationsSelector = createSelectorFromUtil(getPurchaseRequestTermsFromProductConfigurations, transformState);